import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import createPersistedState from 'vuex-persistedstate'
import _this from "../main.js";

Vue.use(Vuex);

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// });

export default new Vuex.Store({
  state: {
    authorization:'',
    refreshToken:'',
    refreshTokenFlag: true, //是否初始化refresh_token
    userInfo:{},//登录人信息
    navInfo:{},//导航栏信息
    sidebarList:[],//左侧菜单列表
    pageTitle:'',
    isAdmin:'',
  },
  mutations: {
    deleteAllMenuList(state) {
      delete state.curryRouter
      delete state.managementSystemRouter
      delete state.clientMenuList
      delete state.mobileMenuList
      delete state.navInfo
      delete state.refreshToken
      delete state.refreshTokenFlag
      delete state.systemMenuList
      delete state.headerKeyword
      delete state.authorization
      delete state.userInfo
      delete state.pageClientWidth
      delete state.personalFolderList
      delete state.randomCode
      delete state.shareCode
      delete state.personalTransferFileList
      delete state.personalFileUploadingObjUid
      delete state.personalFileUploadingObjPercentage
      delete state.usedCapacity
      delete state.enterpriseList
      delete state.companyId
      delete state.companyUserRole
      delete state.enterpriseFolderList
      delete state.enterpriseTransferFileList
      delete state.enterpriseFileUploadingObjUid
      delete state.enterpriseFileUploadingObjPercentage
      delete state.enterpriseUsedCapacity
      delete state.projectId
      delete state.pageTitle
      delete state.menuId
      delete state.isAdmin
      delete state.sidebarList
    },

    //存储authorization方法
    setAuthorization(state, authorization) {
      state.authorization = authorization
    },
    //存储refreshToken方法
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
    },
    setRefreshTokenFlag(state, refreshTokenFlag) {
      state.refreshTokenFlag = refreshTokenFlag
    },
    setNavInfo(state, navInfo) {
      state.navInfo = navInfo
    },
    //存储用户信息方法
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setPageTitle(state, pageTitle){
      state.pageTitle = pageTitle
    },
    setIsAdmin(state, isAdmin){
      state.isAdmin = isAdmin
    },
    setSidebarList(state, sidebarList){
      state.sidebarList = sidebarList
    },
  },
  getters: {
    sidebarList:state => state.sidebarList,
    navInfo:state => state.navInfo,
  },
  actions: {},
  plugins: [
    createPersistedState({
      key:'user',
      paths:['authorization','userInfo','navInfo','sidebarList','pageTitle','isAdmin','refreshToken','refreshTokenFlag']
    })
  ],
});
